import React from "react";

// functions
import { decimalOrBust } from "../../utilities/currency";
import { resize } from "../../services/cloudinaryService";
import { config } from "../../config/";

function selectAndFormatRange(range = "", name = "") {
  const retVal = range || name;
  return retVal[0]
    ? `${retVal[0].toUpperCase()}${retVal.slice(1).toLowerCase()}`
    : "";
}

function selectAndFormatDescription(webDescription = "") {
  return webDescription || "";
}

function selectAndFormatSwatch(swatchColour = "") {
  return swatchColour ? `in ${swatchColour.toLowerCase()}` : "";
}

function formatPrice(price) {
  return `£${decimalOrBust(price)}`;
}

function getRangeLink(range, item) {
  if (!range) range = item.product.code;

  range = range.toUpperCase();

  if (range.startsWith("SOFASHIELD")) range = "SOFASHIELD";

  switch (range.toUpperCase()) {
    case "LEATHERCAREKIT":
    case "FABRICCAREKIT":
      return "";
    case "SOFASHIELD":
    case "SOFAGLIDE":
      return `${config.URLS.SOFOLOGY_HOME}/sofology/${range}`;
    default:
      return `${config.URLS.SOFOLOGY_HOME}/sofas/${range
        .toLowerCase()
        .replace(" ", "-")}?code=${item.product.code}`;
  }
}

function BasketItem({ item, hideQuantity, hideDiscount }) {
  const { totalPrice, wasPrice, quantity = 1 } = item;
  const { range, name, swatchColour, scoopImage, webDescription } = item.product;

  const itemDescription = selectAndFormatDescription(webDescription);
  const formattedRange = selectAndFormatRange(range, name);
  const swatchDescription = selectAndFormatSwatch(swatchColour);
  const formattedPrice = formatPrice(totalPrice.value);
  // was price is based on single item value
  const formattedWasPrice = formatPrice(wasPrice.value * quantity);
  const isDiscounted = totalPrice.value !== wasPrice.value * quantity;
  const rangeLink = getRangeLink(range, item);

  const imageAltText = [formattedRange, itemDescription, swatchDescription]
    .filter(Boolean)
    .join(' ') || 'Basket item';

  return (
    <li>
      <div className="basket__item u-padding-top-small u-padding-bottom-small u-padding-right-small">
        <div className="image-wrap">
          {rangeLink !== "" ? (
            <a href={rangeLink}>
              <img src={resize(scoopImage)} alt={imageAltText} />
            </a>
          ) : (
            <img src={resize(scoopImage)} alt={""} />
          )}
          {!hideQuantity && quantity > 1 && (
            <span className="quantity">x{quantity}</span>
          )}
        </div>

        <div className="description u-padding-left-small">
          <div className="range">{formattedRange}</div>
          <div className="web-description">{itemDescription}</div>
          <div className="swatch">{swatchDescription}</div>
        </div>
      </div>

      <div className="basket__value u-padding-small u-padding-top-medium">
        <div>{formattedPrice}</div>
        {!hideDiscount && isDiscounted ? (
          <div>
            <strike>{formattedWasPrice}</strike>
          </div>
        ) : null}
      </div>
    </li>
  );
}

export default BasketItem;



// WEBPACK FOOTER //
// ./src/parts/HybrisBasket/BasketItem.js